import React, { useState, useEffect, Fragment } from 'react';
import { Button, ButtonGroup, Row, Col, CardBody } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faClipboardCheck, faCheck, faBan, faClock } from "@fortawesome/free-solid-svg-icons";
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import AlertModal from '../../../shared/components/Modal';

const PreviewImage = ({
    index,
    img,
    showImg,
    changeStateImage,
    confirmSuccessChanceStateImage,
    sendNotificationImageApproveDecline
}) => {

    const [decision, setDecision] = useState(null);
    const [openDecision, setOpenDecision] = useState(false);
    const [observationDecision, setObservationDecision] = useState("");

    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const approveDecision = () => {
        setDecision(true);
        setOpenDecision(true);
    }

    const declineDecision = () => {
        setDecision(false);
        setOpenDecision(true);
    }

    const closeDecision = () => {
        setDecision(null);
        setOpenDecision(false);
    }

    const preConfirmApproveImage = () => {
        let message = "";
        if (decision == true) {
            message = "Esta completamente seguro de aprobar esta imagen?"
        }
        else {
            message = "Esta completamente seguro de rechazar esta imagen?"
        }
        setAlertMessageModal(message);
        setAlertColorModal("warning");
        setAlerShowModal(true);
    }

    const confirmApproveImage = async () => {
        if (decision != null) {
            try {
                await changeStateImage(img, decision, observationDecision);
                let message = "Imagen Aprobada con Exito";
                if (decision != true) {
                    message = "Imagen Rechazada con Exito";
                }
                await setAlertMessageModal("");
                await setAlertColorModal("info");
                await setAlerShowModal(false);
                await sendNotificationImageApproveDecline(decision);
                await closeDecision();
            }
            catch (err) {
                await setAlertMessageModal("");
                await setAlertColorModal("info");
                await setAlerShowModal(false);
            }
        }
    }

    const onOkModal = async () => {
        switch (colorAlertModal) {
            case "success":
                await setAlertMessageModal("");
                await setAlertColorModal("info");
                await setAlerShowModal(false);
                await closeDecision();
                await confirmApproveImage();
                break;
            case "warning":
                await confirmApproveImage();
                await setAlertMessageModal("");
                await setAlertColorModal("info");
                await setAlerShowModal(false);
                break;
            case "danger":
                await setAlertMessageModal("");
                await setAlertColorModal("info");
                await setAlerShowModal(false);
                break;
        }
    }

    const onToggleModal = async () => {
        switch (colorAlertModal) {
            case "success":
                await setAlertMessageModal("");
                await setAlertColorModal("info");
                await setAlerShowModal(false);
                await closeDecision();
                break;
            case "warning":
                await setAlertMessageModal("");
                await setAlertColorModal("info");
                await setAlerShowModal(false);
                break;
            case "danger":
                await setAlertMessageModal("");
                await setAlertColorModal("info");
                await setAlerShowModal(false);
                break;
        }
    }


    // useEffect(()=>{
    //     var miDiv = document.getElementById(`min-${index}`);

    //     miDiv.addEventListener('touchstart', function(event) {
            
    //     });
        
    //     miDiv.addEventListener('touchmove', function(event) {
    //         console.log("click en la img touchmove");
    //         // Acción durante el movimiento del toque (si es necesario)
    //     });
        
    //     miDiv.addEventListener('touchend', function(event) {
    //         // Acción al finalizar el toque
    //         console.log("click en la img touchend");
    //     });    
    // },[img.seleccionado])

   
    return (<Fragment key={index}>
        {img.seleccionado == true ?
            <><hr style={{ backgroundColor: 'white', color: 'white', opacity: '0.8' }} />
                <Row>
                    <Col>
                        <div key={index} className="cornerstone-min-diagnostic-image" style={{ cursor: 'pointer' }} id={"min-" + index} onClick={() => {
                            showImg(img);
                        }} onTouchStart={()=>{
                            showImg(img);
                        }} >
                        </div>
                    </Col>
                    <Col style={{ margin: 0 }}>
                        <div style={{ fontSize: '12px', marginTop: 15 }}>
                            <label style={{ color: "white", opacity: 1 }}><FontAwesomeIcon icon={faCalendar} />&nbsp;<b style={{ color: "white", opacity: 1 }}>{img.fecha}</b></label>
                            <br />
                            <label style={{ color: "white", opacity: 1 }}><FontAwesomeIcon icon={faClock} />&nbsp;<b style={{ color: "white", opacity: 1 }}>{img.hora}</b></label>
                            <br />
                            {
                                img.estado == 1 ? <>
                                    <label style={{ color: "white", opacity: 1 }}><b style={{ color: '#FD7E14' }}><FontAwesomeIcon icon={faClipboardCheck} />&nbsp;Pendiente</b></label>
                                </> : null
                            }
                            {
                                img.estado == 2 ? <>
                                    <label style={{ color: "white", opacity: 1 }}><b style={{ color: '#28A745' }}><FontAwesomeIcon icon={faClipboardCheck} />&nbsp;Aprobado</b></label>
                                </> : null
                            }
                            {
                                img.estado == 3 ? <>
                                    <label style={{ color: "white", opacity: 1 }}><b style={{ color: '#DC3545' }}><FontAwesomeIcon icon={faClipboardCheck} />&nbsp;Rechazado</b></label>
                                </> : null
                            }
                        </div>
                        <ButtonGroup size="small" aria-label="small outlined button group">
                            <Tooltip title="Aprobar">
                                <Button style={{ backgroundColor: 'black' }} disabled={img.estado != 1} className="btn btn-sm" color="success" onClick={() => approveDecision()}>
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Rechazar">
                                <Button style={{ backgroundColor: 'black' }} disabled={img.estado != 1} className="btn btn-sm" color="danger" onClick={() => declineDecision()}>
                                    <FontAwesomeIcon icon={faBan} />
                                </Button>
                            </Tooltip>
                        </ButtonGroup>
                    </Col>
                </Row>

                <Modal
                    open={openDecision}
                    onClose={() => closeDecision()}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000, display: "block !important", }}
                    disableScrollLock={false}
                    disableEnforceFocus={true}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <div>
                            <div className="card__title">
                                {decision == true ? <h5 className="bold-text">Aprobar Imagen</h5>
                                    : <h5 className="bold-text">Rechazar Imagen</h5>
                                }
                            </div>
                            <div>
                                <TextField
                                    required
                                    style={{ width: '100%' }}
                                    className="medical-material-form__field"
                                    id="observation-standard-required"
                                    label="Observacion"
                                    type="text"
                                    value={observationDecision}
                                    onChange={(e) => {
                                        setObservationDecision(e.target.value);
                                    }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                        <br />
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                style={{ marginRight: 10, marginLeft: 10 }}
                                variant="contained"
                                onClick={() => {
                                    closeDecision();
                                }}
                            >
                                Cerrar
                            </Button>
                            <Button
                                style={{ marginRight: 10, marginLeft: 10 }}
                                variant="contained"
                                color='primary'
                                onClick={() => {
                                    preConfirmApproveImage();
                                }}
                            >
                                Confirmar
                            </Button>
                        </div>
                    </div>

                </Modal>

            </> : null}

        <AlertModal
            color={colorAlertModal}
            title={messagAlerteModal}
            modal={showAlertModal}
            onOk={() => {
                onOkModal();
            }}
            toggle={() => onToggleModal()}
        />
    </Fragment>)
}

export default PreviewImage;